import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // url: "http://192.168.0.134:2020/",
        picUrl: "https://jump.eqsfood.com.cn/",
        url: "https://jump.eqsfood.com.cn/",
        userInfo: null,
        token: ""
    },
    mutations: {
        userInfoSet(state, userInfo) {
            state.userInfo = userInfo
        }
    }
})
export default store


// WEBPACK FOOTER //
// ./src/vuex/index.js